module.exports = __webpack_public_path__ + "static/media/P1060865.1eb0e676.JPG";